import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100% - 74px);

  @media (max-width: 949px) {
    height: calc(100% - 60px);
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const MessageBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 556px;
  gap: 30px;
  padding: 20px 0;
  margin: 0 15px;
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

export const Title = styled(Typography.Title)`
  @media (max-width: 949px) {
    font-size: 26px;
  }
`;

export const Description = styled(Typography.Caption)`
  font-size: 15px;
  text-align: center;
`;
